module.exports = __webpack_public_path__ + "static/media/angle-up.246e0a93.svg";